module.exports = __webpack_public_path__ + "img/banner_m.bb334133.jpg";